var render = function() {
  var _obj, _obj$1, _obj$2
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "navigation-main" }, [
    _c(
      "div",
      {
        staticClass: "icon-l",
        class:
          ((_obj = {}),
          (_obj["btn-primary"] = _vm.tabSelected === "list"),
          _obj),
        on: {
          click: function($event) {
            return _vm.changeTab("list")
          }
        }
      },
      [
        _c("i", { staticClass: "fa-solid fa-list" }),
        _vm._v("\n        Liste\n    ")
      ]
    ),
    _c(
      "div",
      {
        staticClass: "icon-l",
        class:
          ((_obj$1 = {}),
          (_obj$1["btn-primary"] = _vm.tabSelected === "planner"),
          _obj$1),
        on: {
          click: function($event) {
            return _vm.changeTab("planner")
          }
        }
      },
      [
        _c("i", { staticClass: "fa-regular fa-calendar" }),
        _vm.tabSelected === "planner"
          ? [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.currentViewType == "timeGridWeek" ? "Semaine" : "Mois"
                  ) +
                  "\n            "
              ),
              _c("i", { staticClass: "fa-solid fa-caret-down" })
            ]
          : [_vm._v("\n            Calendrier\n        ")]
      ],
      2
    ),
    _c(
      "div",
      {
        staticClass: "icon-l",
        class:
          ((_obj$2 = {}),
          (_obj$2["btn-primary"] = _vm.tabSelected === "feed"),
          (_obj$2.disable = !_vm.isPageInstagramSelected),
          _obj$2),
        on: {
          click: function() {
            return _vm.isPageInstagramSelected && _vm.changeTab("feed")
          }
        }
      },
      [
        _c("i", { staticClass: "fa-brands fa-instagram" }),
        _vm._v("\n        Feed\n    ")
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }